import { render, staticRenderFns } from "./PartsdataLogo.vue?vue&type=template&id=205a84e1&scoped=true&"
import script from "./PartsdataLogo.vue?vue&type=script&lang=js&"
export * from "./PartsdataLogo.vue?vue&type=script&lang=js&"
import style0 from "./PartsdataLogo.vue?vue&type=style&index=0&id=205a84e1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a84e1",
  null
  
)

export default component.exports